import { notification } from "antd";
import { ILoginUserData, ICurrentHover, ILockedModal } from "../Models/Models";
import {
    GET_LOGIN_USER_DATA_FAILURE,
    GET_LOGIN_USER_DATA_SUCCESS,
    LoginActionType,
    SET_FETCHING_LOGIN_USER_DATA,
    SET_CURRENT_HOVER,
    SET_LOCKED_MODAL,
} from "../Types/LoginActionTypes";

export interface ILoginReducerState {
    firstName: string;
    lastName: string;
    initials: string;
    featureAccess: string[];
    fetchingLoginUserData: boolean;
    userID: number;
    currentHover: ICurrentHover;
    lockedModal: ILockedModal;
}
export const loginReducerState: ILoginReducerState = {
    firstName: "",
    lastName: "",
    initials: "",
    featureAccess: null,
    fetchingLoginUserData: false,
    userID: -1,
    currentHover: {
        app: null,
        title: "",
        image: "",
        header: "",
        description: "",
    },
    lockedModal: {
        visible: false,
        title: "",
        description: "",
        link: "",
        linkText: "",
    }
};

export const loginReducer = (state = { ...loginReducerState }, action: LoginActionType): ILoginReducerState => {
    switch (action.type) {
        /** misc */
        case SET_FETCHING_LOGIN_USER_DATA: {
            return {
                ...state,
                fetchingLoginUserData: action.data as boolean,
            };
        }
        /** success */
        case GET_LOGIN_USER_DATA_SUCCESS: {
            const data = action.data as ILoginUserData;
            return {
                ...state,
                firstName: data.firstName,
                lastName: data.lastName,
                initials: data.initials,
                featureAccess: data.featureAccess as string[],
                userID: data.userID
            };
        }
        /** failure */
        case GET_LOGIN_USER_DATA_FAILURE: {
            notification.error({
                message: "Error getting Login User Data",
                description: action.data,
            });
            return {
                ...state,
            };
        }
        /* hover */
        case SET_CURRENT_HOVER: {
            return {
                ...state,
                currentHover: action.data as ICurrentHover,
            };
        }
        case SET_LOCKED_MODAL: {
            return {
                ...state,
                lockedModal: action.data as ILockedModal,
            };
        }
        default: {
            return state;
        }
    }
};
